import axios from '../utilities/axios'

async function claimCouponValidation(couponCode) {
  if (couponCode.length < 15 || couponCode.length > 16) {
    throw new Error('error.coupon.couponNotValid')
  }
}
async function claimTokenValidation(tokenCode) {
  if (tokenCode.length > 20) {
    throw new Error('error.coupon.couponNotValid')
  }
}

async function claimCouponCode(couponCode, webGL, captchaToken) {
  const hardware = webGL ? Buffer.from(webGL).toString('base64') : null
  return axios.post('/api/v1/claim/coupon', { couponCode, hardware, captchaToken })
}

async function claimTokenCode(tokenCode, webGL, captchaToken) {
  const hardware = webGL ? Buffer.from(webGL).toString('base64') : null
  return axios.post('/api/v1/claim/token', { tokenCode, hardware, captchaToken })
}

async function getPromotion(promotionId) {
  return axios.get(`/api/v1/promotion/${promotionId}`)
}

async function getPromotionByCouponCode(couponCode) {
  return axios.get(`/api/v1/promotion/?couponCode=${couponCode}`)
}

async function redeemContent(redemptions, webGL) {
  const hardware = webGL ? Buffer.from(webGL).toString('base64') : null
  return axios.post('/api/v1/claim/redeem', { ...redemptions, hardware })
}

async function emailRedemption(redemptionId) {
  return axios.post('/api/v1/redemption/email', { redemptionId })
}

async function getSurveyByCouponCode(couponCode) {
  return axios.get(`/api/v1/survey/?couponCode=${couponCode}`)
}

async function checkCompletedSurvey(redemptionId) {
  return axios.post('/api/v1/claim/surveyCheck', { redemptionId })
}

async function getCouponKeyWithTokenKey(tokenKey) {
  return axios.post('/api/v1/claim/getCouponKey', { tokenKey })
}

export default {
  claimCouponCode,
  claimTokenCode,
  claimCouponValidation,
  claimTokenValidation,
  getPromotion,
  getPromotionByCouponCode,
  redeemContent,
  emailRedemption,
  getSurveyByCouponCode,
  checkCompletedSurvey,
  getCouponKeyWithTokenKey,
}
